<template>
  <div class="modal modal-filter-details fade" id="modal-import-social-media-csv" role="dialog" aria-labelledby="shortlist-modal-label" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Import Social Media CSV</h4>
        </div>
        <div class="modal-body">
          <div class="form-horizontal">
            <div :class="['form-group', errorClass('csv_input')]">
              <div class="col-sm-5">
                <div class="file-upload-control">
                  <input
                    name="csv"
                    id="csv"
                    type="file"
                    @change="handleFileSelectionCallback"
                    @input="handleFileSelectionCallback"
                    accept=".csv">
                  <label for="csv" class="btn btn-default btn-block">Select CSV File</label>
                </div>
              </div>

              <div :class="$hasErrorClass($v.fileName, 'col-sm-7')">
                <input
                  class="form-control"
                  name="csv_input"
                  type="text"
                  :value="$v.fileName.$model"
                  readonly/>

                <vuelidate-help label="File name" :field="$v.fileName" />
              </div>
            </div>
          </div>

          <div v-if="importingComplete">
            <template v-if="haveFailedRecords">
              <div class="alert alert-info">
                Your import completed successfully however the records below failed to import due to validation errors.
              </div>

              <table class="table">
                <tr>
                  <th>ID</th>
                  <th>Email</th>
                  <th>Facebook Followers</th>
                  <th>Twitter Followers</th>
                  <th>Instagram Followers</th>
                </tr>
                <tr v-for="(fail, index) in failed" :key="index">
                  <td>{{ fail.id }}</td>
                  <td>{{ fail.email }}</td>
                  <td>{{ fail.facebook_follower_count }}</td>
                  <td>{{ fail.twitter_follower_count }}</td>
                  <td>{{ fail.instagram_follower_count }}</td>
                </tr>
              </table>
            </template>
            <div class="alert alert-success" v-else>
              Your import completed successfully.
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-lg btn-danger pull-left" data-dismiss="modal"><i class="fa fa-close"></i> Cancel</button>
          <ladda-button
            type="button"
            class="btn btn-lg btn-primary"
            :click="handleProcessCsvImportCallback">
            <i class="fa fa-check"></i> Process Import
          </ladda-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import $ from 'jquery'
import { required } from 'vuelidate/lib/validators'
import VuelidateHelp from '../misc/VuelidateHelp'
import { notify } from 'utils'

export default {
  components: { VuelidateHelp },

  validations: {
    fileName: {
      required
    }
  },

  data () {
    return {
      file: null,
      importingComplete: false,
      failed: []
    }
  },

  watch: {
    file () {
      if (this.file === null) {
        document.getElementById('csv').value = ''
      }
    }
  },

  computed: {
    fileName () {
      if (this.file) {
        return this.file.name
      }

      return null
    },

    haveFailedRecords () {
      return this.failed.length > 0
    }
  },

  mounted () {
    $(this.$el).on('hide.bs.modal', () => {
      this.file = null
      this.importingComplete = false
      this.failed = []
    })

    $(this.$el).on('show.bs.modal', () => {
      this.$validator.reset()
    })
  },

  methods: {
    ...mapActions('system', ['processTalentCsvImport']),

    /**
     * Handle file selection.
     *
     * This pulls the file from the input box and sets it on the cropper instance.
     *
     * @return void
     */
    handleFileSelectionCallback ({ target: { files } }) {
      if (files.length === 0) {
        this.file = null

        return
      }

      this.file = files.item(0)

      this.$validator.reset()
    },

    /**
     * Process CSV import.
     *
     * @return Promise
     */
    handleProcessCsvImportCallback () {
      if (this.$v.$invalid) {
        this.$v.$touch()
        notify.error(`Some fields failed validation. Please fix them and try again`)
        return Promise.resolve()
      }
      return this.validate()
        .then(() => {
          return this.processTalentCsvImport(this.file)
        })
        .then((response) => {
          this.file = null
          this.importingComplete = true
          this.failed = response.data.failed

          this.$validator.reset()
        })
    }
  }
}
</script>
